import { render, staticRenderFns } from "./InterfaceWeb.vue?vue&type=template&id=4268e180&scoped=true&"
import script from "./InterfaceWeb.vue?vue&type=script&lang=js&"
export * from "./InterfaceWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4268e180",
  null
  
)

export default component.exports